import React, { PureComponent } from 'react';
import Modal from '../../../../components/Modal';
import { Form, FormGroup, SubmitButton, FormError } from '../../../../components/Forms/Forms';
import { Input, Select, Textarea } from '../../../../components/Forms/fields/index';
import rules from '../../../../components/Forms/rules';
import enums from '../../../../constants/enums';

class CreateTransactionView extends PureComponent {
  render() {
    const {
      closeCreateModal,
      createModalActive,
      formState,
      submitForm,
      onFormUpdate,
    } = this.props;

    // from, to, amountFrom, amountTo, currencyFrom, currencyTo, description

    return (
      <Modal active={createModalActive} onClose={closeCreateModal}>
        <h3>Create Transaction</h3>
        <div className="transaction-create-form">
          <Form state={formState} onSubmit={submitForm} onChange={onFormUpdate}>
            <div className="account-groups">
              <div className="account-group account-from">
                <h5>From</h5>
                <FormGroup>
                  <label>Account</label>
                  <Select
                    name="from"
                    options={enums.accounts}
                    emptyOption
                    validate={[rules.required()]}
                  />
                  <FormError/>
                </FormGroup>

                <FormGroup>
                  <label>Amount</label>
                  <Input name="amountFrom" type="number" validate={[rules.required()]}/>
                  <FormError/>
                </FormGroup>

                <FormGroup>
                  <label>Currency</label>
                  <Select
                    name="currencyFrom"
                    options={['USD', 'BTC', 'GFC']}
                    emptyOption
                    validate={[rules.required()]}
                  />
                  <FormError/>
                </FormGroup>
              </div>
              <div className="account-group account-to">
                <h5>To</h5>

                <FormGroup>
                  <label>Account</label>
                  <Select
                    name="to"
                    options={enums.accounts}
                    emptyOption
                    validate={[rules.required()]}
                  />
                  <FormError/>
                </FormGroup>

                <FormGroup>
                  <label>Amount</label>
                  <Input name="amountTo" type="number" validate={[rules.required()]}/>
                  <FormError/>
                </FormGroup>

                <FormGroup>
                  <label>Currency</label>
                  <Select
                    name="currencyTo"
                    options={['USD', 'BTC', 'GFC']}
                    emptyOption
                    validate={[rules.required()]}
                  />
                  <FormError/>
                </FormGroup>
              </div>
            </div>

            <FormGroup>
              <label>Date</label>
              <Input name="date" type="date" validate={[rules.required()]}/>
            </FormGroup>

            <FormGroup>
              <label>Description</label>
              <Textarea name="description" />
            </FormGroup>



            <button type="submit" className="button">Create</button>
          </Form>
        </div>
      </Modal>
    )
  }
}

export default CreateTransactionView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Ledger/CreateTransaction/CreateTransaction.view.js